<template>
  <bulk-paymethod-whitelist
    :is-loading="isLoading"
    :paymethods="paymethods"
    @project-selected="loadPaymethods"
    @bulk-update="onBulkUpdateWhitelist"
    @whitelist-all="onWhitelistAll"
  />
</template>

<script>
import { map } from 'lodash'
import { API } from '@/utils/api'
import BulkPaymethodWhitelist from '../components/BulkPaymethodWhitelist.vue'

export default {
  components: {
    BulkPaymethodWhitelist
  },

  data() {
    return {
      isLoading: false,
      paymethods: [],
    }
  },

  mounted() {},

  methods: {
    loadPaymethods(entity_id) {
      this.isLoading = true
      this.paymethods = []
      return API.call('/$v/paymethod/name_list.json', {
        entity_id,
        whitelisted: true,
      })
        .then(r => this.paymethods = map(r.data, 'name'))
        .finally(() => this.isLoading = false)
    },
    onBulkUpdateWhitelist(args) {
      this.isLoading = true
      return API.call('/$v/account/bulk_update.json', args)
        .then(() => {
          this.$showSuccess('Updated successfully')
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    onWhitelistAll(args) {
      this.isLoading = true

      return API.call('/$v/tools/whitelist_all.json', args)
        .then((r) => {
          this.$showSuccess(`Successfully updated ${r.data} accounts`)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>
